import {
	CREATE_PAGE_EXPERIENCE,
	CREATE_AND_EDIT_PAGE_EXPERIENCE,
	getExperienceTracker, // eslint-disable-line no-restricted-imports
} from '@confluence/experience-tracker';
import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import { getStandalonePageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container/entry-points/getStandalonePageTreeStateUpdater';

const messageCallbacks = new Map();

export default {
	// for payload structure, see: https://bitbucket.org/atlassian/analytics-web-client
	// NOTE: sendIdentifyEvent is not yet implemented here due to requiring two arguments instead of a single payload
	ATLASSIAN_CONFLUENCE_ANALYTICS_NEXT_TRACK(payload) {
		getAnalyticsWebClient().then((analyticsWebClient) =>
			analyticsWebClient.sendTrackEvent(payload),
		);
	},
	ATLASSIAN_CONFLUENCE_ANALYTICS_NEXT_SCREEN(payload) {
		getAnalyticsWebClient().then((analyticsWebClient) =>
			analyticsWebClient.sendScreenEvent(payload),
		);
	},
	ATLASSIAN_CONFLUENCE_ANALYTICS_NEXT_UI(payload) {
		getAnalyticsWebClient().then((analyticsWebClient) => analyticsWebClient.sendUIEvent(payload));
	},
	ATLASSIAN_CONFLUENCE_ANALYTICS_NEXT_OPERATIONAL(payload) {
		getAnalyticsWebClient().then((analyticsWebClient) =>
			analyticsWebClient.sendOperationalEvent(payload),
		);
	},
	ATLASSIAN_CONFLUENCE_EXPERIENCE_START(payload) {
		getExperienceTracker().start(payload);
	},
	ATLASSIAN_CONFLUENCE_EXPERIENCE_SUCCEED(payload) {
		getExperienceTracker().succeed(payload);
	},
	ATLASSIAN_CONFLUENCE_EXPERIENCE_FAIL(payload) {
		getExperienceTracker().fail(payload);
	},
	ATLASSIAN_CONFLUENCE_EXPERIENCE_ABORT(payload) {
		getExperienceTracker().abort(payload);
	},

	ATLASSIAN_CONFLUENCE_VARIABLEINPUT_GET_TEMPLATEINFO(payload) {
		const callback = messageCallbacks.get('ATLASSIAN_CONFLUENCE_VARIABLEINPUT_GET_TEMPLATEINFO');
		if (typeof callback === 'function') {
			callback(payload);
		} else {
			const error = new Error(
				'no handler registered for ATLASSIAN_CONFLUENCE_VARIABLEINPUT_GET_TEMPLATEINFO. Template variables input not rendered.',
			);
			getExperienceTracker().fail({
				name: CREATE_PAGE_EXPERIENCE,
				error,
			});
		}
	},
	// sets a callback function into the CreateDialagContainer
	ATLASSIAN_CONFLUENCE_VARIABLEINPUT_REGISTER_CALLBACK(payload) {
		const callback = payload; // { onSubmit(templateId,spacekey,parentPageId) }
		messageCallbacks.set('ATLASSIAN_CONFLUENCE_VARIABLEINPUT_GET_TEMPLATEINFO', callback);
	},
	ATLASSIAN_CONFLUENCE_NEW_SPACE_WIZARD(payload) {
		const callback = messageCallbacks.get('ATLASSIAN_CONFLUENCE_NEW_SPACE_WIZARD');
		if (typeof callback === 'function') {
			callback(payload);
		}
	},
	ATLASSIAN_CONFLUENCE_NEW_SPACE_REGISTER_CALLBACK(payload) {
		const callback = payload;
		messageCallbacks.set('ATLASSIAN_CONFLUENCE_NEW_SPACE_WIZARD', callback);
	},
	ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE_CALLBACK(payload) {
		const callback = payload;
		messageCallbacks.set('ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE', callback);
	},
	ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE(payload) {
		const callback = messageCallbacks.get('ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE');
		if (typeof callback === 'function') {
			callback(payload);
		} else {
			const error = new Error(
				'no handler registered for ATLASSIAN_CONFLUENCE_CREATE_PAGE_NAVIGATE. No navigation change.',
			);
			getExperienceTracker().fail({
				name: CREATE_AND_EDIT_PAGE_EXPERIENCE,
				error,
			});
		}
	},
	ATLASSIAN_CONFLUENCE_EDIT_SPACE_LOGO(payload) {
		const callback = messageCallbacks.get('ATLASSIAN_CONFLUENCE_EDIT_SPACE_LOGO');
		if (typeof callback === 'function') {
			callback(payload);
		}
	},
	ATLASSIAN_CONFLUENCE_EDIT_SPACE_LOGO_REGISTER_CALLBACK(payload) {
		const callback = payload;
		messageCallbacks.set('ATLASSIAN_CONFLUENCE_EDIT_SPACE_LOGO', callback);
	},
	ATLASSIAN_CONFLUENCE_REFRESH_CONTENT_TREE({ contentId }) {
		getStandalonePageTreeStateUpdater().setForceFetchPageId(contentId);
	},
};
